import { addMinutes, isAfter, roundToNearestMinutes } from "date-fns";

const MAX_ETA_MINUTES = 60;
const ETA_INCREMENT_MINUTES = 10;

interface GetInterviewEtaAvailableTimesParams {
  interviewStart: Date;
  now: Date;
}

/**
 * Generate available ETA time options for an interview.
 * Times are generated in 10-minute increments up to 60 minutes from the base time.
 * The base time is either the interview start or the current time (rounded up to nearest 10 minutes),
 * whichever is later.
 */
export function getInterviewEtaAvailableTimes(params: GetInterviewEtaAvailableTimesParams): Date[] {
  const { interviewStart, now } = params;

  const roundedNow = roundToNearestMinutes(now, { nearestTo: ETA_INCREMENT_MINUTES });

  const baseTime = isAfter(roundedNow, interviewStart) ? roundedNow : interviewStart;

  const times: Date[] = [];
  for (
    let minutes = ETA_INCREMENT_MINUTES;
    minutes <= MAX_ETA_MINUTES;
    minutes += ETA_INCREMENT_MINUTES
  ) {
    times.push(addMinutes(baseTime, minutes));
  }

  return times;
}
